// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2GrIA","actions":"GroupTable_actions__1yeH_","deleteModalFooter":"GroupTable_deleteModalFooter__X31Wx"};